export default "__VITE_PUBLIC_ASSET__387d8000__"